import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	addresses: [],
	AmlBlockchainsSettings: null,
	AmlLevelsDefault: { Low: 25, Medium: 75 },
};

export const addressSlice = createSlice({
	name: 'address',
	initialState,
	reducers: {
		resetState: () => initialState,
		setAddresses: (state, action) => {
			const { payload: addresses = [] } = action;
			state.addresses = addresses;
		},
		setAmlSettings: (state, action) => {
			const { payload } = action;
			state.AmlBlockchainsSettings = payload.AmlBlockchainsSettings;
			state.AmlLevelsDefault = payload.AmlLevelsDefault.AmlLevels;
		},
	},
});
